(() => {
  'use strict';
  if (window.ELStoreAnalytics) return;

  const storageKey = 'easylonger:attribution:v3';
  const attributionKeys = ['gclid', 'gbraid', 'wbraid', 'utm_id', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  const clean = value => String(value || '').trim().slice(0, 160).replace(/[^a-zA-Z0-9._~-]/g, '_');
  const readStored = () => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      const parsed = raw ? JSON.parse(raw) : {};
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
      return attributionKeys.reduce((result, key) => {
        if (typeof parsed[key] === 'string' && parsed[key]) result[key] = parsed[key];
        return result;
      }, {});
    } catch (_) { return {}; }
  };
  const query = new URLSearchParams(window.location.search);
  const queryAttribution = attributionKeys.reduce((result, key) => {
    const value = query.get(key);
    if (value !== null && value !== '') result[key] = value;
    return result;
  }, {});
  const storedAttribution = readStored();
  const hasLandingAttribution = Object.keys(queryAttribution).length > 0;
  const currentAttribution = hasLandingAttribution ? queryAttribution : storedAttribution;
  const attribution = () => ({...currentAttribution});
  if (hasLandingAttribution) {
    try { sessionStorage.setItem(storageKey, JSON.stringify(currentAttribution)); } catch (_) {}
  }
  const utmContent = () => attribution().utm_content || 'direct_or_unset';
  const eventBuffer = window.__elAnalyticsEvents = window.__elAnalyticsEvents || [];

  const track = (name, payload = {}) => {
    const productModel = clean(payload.product_model || payload.recommended_model || payload.model || 'not_selected');
    const customData = {
      ...payload,
      model: productModel,
      product_model: productModel,
      ...(payload.cpap_model ? {cpap_model: clean(payload.cpap_model)} : {}),
      utm_content: utmContent(),
      page_path: window.location.pathname
    };
    eventBuffer.push({name, data: customData});
    document.dispatchEvent(new CustomEvent(`easylonger:${name}`, {detail: customData}));
    if (window.Shopify?.analytics?.publish) {
      try {
        const published = window.Shopify.analytics.publish(`easylonger:${name}`, customData);
        if (published?.catch) published.catch(() => {});
      } catch (_) {}
    }
    return customData;
  };

  const withUtm = href => {
    if (!href) return href;
    try {
      const url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return href;
      Object.entries(attribution()).forEach(([key, value]) => {
        if (!attributionKeys.includes(key) || !value) return;
        if (url.searchParams.has(key)) url.searchParams.set(key, url.searchParams.get(key));
        else url.searchParams.set(key, value);
      });
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (_) { return href; }
  };

  const prepareLinks = (root = document) => {
    root.querySelectorAll('[data-el-product-link]').forEach(link => {
      link.dataset.elAttributionReady = 'true';
      link.href = withUtm(link.getAttribute('href'));
    });
  };
  const modelFromTitle = title => {
    const match = String(title || '').toUpperCase().match(/\b(ESP110|ES(?:270|400(?:\s+AIR)?|720(?:\s+PRO)?|960(?:\s+PRO)?))\b/);
    return match ? match[1].replace(/\s+/g, ' ') : String(title || 'not_selected');
  };
  const cartState = () => {
    try { return JSON.parse(document.querySelector('[data-el-cart-state]')?.textContent || '{}'); } catch (_) { return {}; }
  };

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-el-track-select]');
    if (!link) return;
    track('select_item', {
      model: link.dataset.model,
      product_model: link.dataset.model,
      product_id: clean(link.dataset.productId),
      variant_id: clean(link.dataset.variantId),
      source: 'shop'
    });
  });
  document.addEventListener('variant:add', event => {
    const item = event.detail?.items?.[0] || {};
    track('add_to_cart', {
      model: modelFromTitle(item.product_title || item.title),
      product_model: modelFromTitle(item.product_title || item.title),
      product_id: clean(item.product_id),
      variant_id: clean(item.variant_id || item.id),
      quantity: Number(item.quantity) || 1,
      source: 'product_form'
    });
  });
  document.addEventListener('click', event => {
    const checkoutControl = event.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!checkoutControl) return;
    const cart = cartState();
    const items = Array.isArray(cart.items) ? cart.items : [];
    track('begin_checkout', {
      model: [...new Set(items.map(item => modelFromTitle(item.product_title || item.title)))].join('|') || 'cart',
      product_model: [...new Set(items.map(item => modelFromTitle(item.product_title || item.title)))].join('|') || 'cart',
      item_count: Number(cart.item_count) || items.reduce((total, item) => total + (Number(item.quantity) || 0), 0),
      source: checkoutControl.closest('cart-drawer') ? 'cart_drawer' : 'cart_page'
    });
  }, true);

  window.ELStoreAnalytics = {track, utmContent, withUtm, prepareLinks};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepareLinks(), {once: true}); else prepareLinks();
  document.addEventListener('shopify:section:load', event => prepareLinks(event.target));
})();
